import axios from 'axios';

const buildPath = (pipelineId, itemId) => {
  const accountId = window.location.pathname.match(/accounts\/(\d+)/)?.[1];
  return `/api/v1/accounts/${accountId}/pipelines/${pipelineId}/items/${itemId}/documents`;
};

export const pipelineItemDocumentsApi = {
  list(pipelineId, itemId) {
    return axios.get(buildPath(pipelineId, itemId));
  },
  upload(pipelineId, itemId, { title, file }) {
    const formData = new FormData();
    formData.append('title', title);
    formData.append('file', file);
    return axios.post(buildPath(pipelineId, itemId), formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  delete(pipelineId, itemId, documentId) {
    return axios.delete(`${buildPath(pipelineId, itemId)}/${documentId}`);
  },
};
